import DesignSelection from "../components/DesignSelection";

const Designs = () => {
  return <DesignSelection />;
};

export default Designs;
